import { TableCard } from '../../../../components'
import { FormulariosListHeader } from './component/header/FormulariosListHeader'
import { QueryResponseProvider } from './core/QueryResponseProvider'
import { FormulariosTable } from './table/FormulariosTable'

const FormulariosList = () => {
  return (
    <TableCard>
      <FormulariosListHeader />
      <FormulariosTable />
    </TableCard>
  )
}

/** O estado da listagem (filtros, página, ordenação) vem do `FormulariosPage`, para sobreviver à ida à edição. */
export const FormulariosListWrapper = () => (
  <QueryResponseProvider>
    <FormulariosList />
  </QueryResponseProvider>
)
